module.exports = __webpack_public_path__ + "img/4-1-1-2-preview-hoteloffer-conrad-e.ec4fb9c3.jpg";